import React from 'react';

const LazyAutoLogin = React.lazy(() =>
  import(/* webpackChunkName: "AutoLogin" */ './autologin')
);

const AutoLogin = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyAutoLogin {...props} />
  </React.Suspense>
);

export default AutoLogin